import { ADBLOCK_IS_INSTALLED_SEND_ANALYTICS } from '../actions/types';

export const adblockGaActionEvents = {
  [ADBLOCK_IS_INSTALLED_SEND_ANALYTICS]: ({ displayableUserId }) => ({
    category: 'adblock',
    action: 'visit',
    label: displayableUserId,
  }),
};
